import Highcharts from "highcharts";

Highcharts.AST.allowedAttributes.push(
  "viewBox",
  "xmlns",
  "stroke-linejoin",
  "clip-path"
);
